import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import api from "../../utils/api";
import { FILE_BASE_URL } from "../../utils/api";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const PrintInstitutionView = () => {
  const { id } = useParams();
  const [institution, setInstitution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [statements, setStatements] = useState([]);
  const [responsibleData, setResponsibleData] = useState(null);

  // دالة الطباعة
  const handlePrint = () => {
    window.print();
  };

  // دالة انتظار تحميل جميع الصور
  const loadAllImages = async () => {
    const images = document.querySelectorAll('.print-content img');
    const promises = Array.from(images).map(img => {
      return new Promise(resolve => {
        if (img.complete && img.naturalHeight !== 0) {
          resolve();
        } else {
          img.onload = () => resolve();
          img.onerror = () => resolve(); // متابعة حتى لو فشلت الصورة
        }
      });
    });
    await Promise.all(promises);
  };

  const blobToDataURL = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  // دالة تحميل PDF (تحويل حقيقي إلى PDF)
  const handleDownloadPDF = async () => {
    const pdfButton = document.querySelector('.print-btn[title="تحميل كـ PDF"]');
    if (!pdfButton) return;

    // تمنع النقر المكرر وتعرض مؤشر تحميل
    setPdfLoading(true);
    try {
      // انتظار تحميل الصور في الصفحة
      await loadAllImages();

      const element = document.querySelector('.print-content');
      if (!element) throw new Error('لم يتم العثور على المحتوى المراد طباعته');

      // اجمع كل روابط الصور (img.src و background-image) داخل .print-content
      const imgs = Array.from(document.querySelectorAll('.print-content img'));
      const bgElems = Array.from(document.querySelectorAll('.print-content *')).filter(el => {
        try {
          const bg = window.getComputedStyle(el).getPropertyValue('background-image');
          return bg && bg !== 'none' && bg.includes('url(');
        } catch (e) {
          return false;
        }
      });

      const urlSet = new Map(); // originalUrl -> dataUrl

      const collectUrls = [];
      imgs.forEach(i => { if (i.src && !i.src.startsWith('data:')) collectUrls.push(i.src); });
      bgElems.forEach(el => {
        try {
          const bg = window.getComputedStyle(el).getPropertyValue('background-image');
          const match = /url\(["']?(.*?)["']?\)/.exec(bg);
          if (match && match[1] && !match[1].startsWith('data:')) collectUrls.push(match[1]);
        } catch (e) {}
      });

      // إزالة التكرارات
      const uniqueUrls = Array.from(new Set(collectUrls));
      const inlined = [];

      for (const originalUrl of uniqueUrls) {
        try {
          console.log('محاولة تضمين URL للـ PDF:', originalUrl);
          let dataUrl = null;
          // محاولة fetch مباشر
          try {
            const res = await fetch(originalUrl, { mode: 'cors' });
            if (res && res.ok) {
              const blob = await res.blob();
              dataUrl = await blobToDataURL(blob);
              console.log('نجاح fetch مباشر:', originalUrl);
            }
          } catch (e) {
            console.warn('fetch مباشر فشل:', originalUrl, e);
          }

          // إذا فشل، جرِّب proxy
          if (!dataUrl) {
            try {
              const marker = '/uploads/images/';
              let proxyPath = originalUrl;
              const idx = originalUrl.indexOf(marker);
              if (idx !== -1) proxyPath = originalUrl.substring(idx + marker.length);
              else {
                const parts = originalUrl.split('/');
                proxyPath = parts[parts.length - 1] || originalUrl;
              }
              const proxyUrl = `${window.location.protocol}//${window.location.hostname}:8000/images/${encodeURIComponent(proxyPath)}`;
              console.log('محاولة fetch عبر proxy:', proxyUrl);
              const pres = await fetch(proxyUrl, { mode: 'cors' });
              if (pres && pres.ok) {
                const blob = await pres.blob();
                dataUrl = await blobToDataURL(blob);
                console.log('نجاح fetch عبر proxy:', originalUrl);
              }
            } catch (e) {
              console.warn('fetch عبر proxy فشل:', originalUrl, e);
            }
          }

          // محاولة رسم العنصر المعروض إذا لم نتمكن من الحصول على dataUrl
          if (!dataUrl) {
            try {
              // ابحث عن عنصر img فعلي في DOM الذي يتطابق src
              const domImg = Array.from(document.querySelectorAll('.print-content img')).find(x => x.src === originalUrl);
              if (domImg) {
                const tmp = document.createElement('canvas');
                const w = domImg.naturalWidth || domImg.width || 100;
                const h = domImg.naturalHeight || domImg.height || 100;
                tmp.width = w; tmp.height = h;
                const ctx = tmp.getContext('2d');
                ctx.drawImage(domImg, 0, 0, w, h);
                dataUrl = tmp.toDataURL('image/png');
                console.log('نجاح رسم العنصر إلى كانفاس:', originalUrl);
              }
            } catch (e) {
              console.warn('رسم العنصر إلى كانفاس فشل:', originalUrl, e);
            }
          }

          if (dataUrl) {
            urlSet.set(originalUrl, dataUrl);
          } else {
            console.warn('لم يتم الحصول على dataUrl للـ URL:', originalUrl);
          }
        } catch (e) {
          console.warn('خطأ عند محاولة تضمين URL:', originalUrl, e);
        }
      }

      // الآن استبدل جميع src و background-image الموجودة في الـ DOM بالـ dataUrls المحصلة
      if (urlSet.size > 0) {
        // صور <img>
        imgs.forEach(img => {
          try {
            const d = urlSet.get(img.src);
            if (d) {
              inlined.push({ img, originalSrc: img.src });
              img.src = d;
            }
          } catch (e) {}
        });

        // الخلفيات
        bgElems.forEach(el => {
          try {
            const bg = window.getComputedStyle(el).getPropertyValue('background-image');
            const match = /url\(["']?(.*?)["']?\)/.exec(bg);
            if (match && match[1]) {
              const d = urlSet.get(match[1]);
              if (d) {
                el.style.backgroundImage = `url('${d}')`;
              }
            }
          } catch (e) {}
        });

        // انتظر تحميل المصادر الجديدة
        await loadAllImages();
      }

      // إعداد html2canvas مع onclone لحذف الأزرار من المستند المستنسخ فقط
      let canvas;
      try {
        canvas = await html2canvas(element, {
          scale: 1.2,
          useCORS: true,
          allowTaint: false,
          backgroundColor: '#ffffff',
          logging: false,
          onclone: (clonedDoc) => {
            // حذف أزرار الطباعة من المستند المُستنسخ حتى لا تظهر في الـ PDF
            const clonedBtns = clonedDoc.querySelectorAll('.print-btn');
            clonedBtns.forEach(b => b.remove());
          }
        });
      } catch (errCanvas) {
        console.warn('html2canvas مع الصور المضمنة فشل، المحاولة مع تجاهل الصور الخارجية:', errCanvas);
        // إعادة محاولة بتجاهل الصور الخارجية لمنع tainted canvas
        canvas = await html2canvas(element, {
          scale: 1.2,
          useCORS: false,
          allowTaint: true,
          backgroundColor: '#ffffff',
          logging: false,
          ignoreElements: (el) => el.tagName === 'IMG' && el.src && !el.src.startsWith('data:')
        });
      }

      // إذا لم يتم توليد كانفاس، فاشارة خطأ
      if (!canvas) throw new Error('فشل في إنشاء صورة لصفحة الـ PDF');

      // إعدادات PDF
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const imgData = canvas.toDataURL('image/png');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const finalWidth = imgWidth * ratio;
      const finalHeight = imgHeight * ratio;
      pdf.addImage(imgData, 'PNG', 0, 0, finalWidth, finalHeight);

      const institutionName = institution?.title || 'مؤسسة';
      const cleanName = institutionName.replace(/[^a-zA-Z0-9\u0600-\u06FF\s]/g, '').trim();
      const fileName = `${cleanName}_profile.pdf`;
      pdf.save(fileName);

      // استعادة مسارات الصور الأصلية التي قمنا بتحويلها
      inlined.forEach(item => {
        try { item.img.src = item.originalSrc; } catch (e) { /* ignore */ }
      });

    } catch (error) {
      console.error('خطأ في تحميل PDF:', error);
      alert('حدث خطأ أثناء تحميل PDF: ' + (error.message || error));
    } finally {
      setPdfLoading(false);
    }
  };

  useEffect(() => {
    fetchInstitution();
  }, []);

  const fetchInstitution = async () => {
    try {
      const response = await api.get(`/institutions/${id}`);
      if (response.data && response.data.data) {
        const institutionData = response.data.data;
        setInstitution(institutionData);

        // تحميل الصور
        if (institutionData.images) {
          try {
            setImages(parseArrayField(institutionData.images));
          } catch (e) {
            setImages([]);
          }
        }

        // تحميل التصريحات الجديدة
        if (institutionData.statements) {
          try {
            setStatements(parseArrayField(institutionData.statements));
          } catch (e) {
            console.error("فشل في قراءة التصريحات:", e);
            setStatements([]);
          }
        }

        // جلب بيانات المسؤول حسب النوع
        console.log("Institution data:", institutionData);
        console.log("Responsible type:", institutionData.responsible_type);
        console.log("Responsible journalist id:", institutionData.responsible_journalist_id);
        console.log("Responsible activist id:", institutionData.responsible_activist_id);
        
        await fetchResponsibleData(institutionData);
      }
    } catch (error) {
      console.error("Error fetching institution:", error);
    } finally {
      setLoading(false);
    }
  };

  const parseArrayField = (field) => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    try {
      return JSON.parse(field);
    } catch {
      return [];
    }
  };

  // دالة لتحديد أيقونة السوشال ميديا حسب نوع الحساب
  const getSocialMediaIcon = (url) => {
    const urlLower = url.toLowerCase();
    
    if (urlLower.includes('facebook') || urlLower.includes('fb.com')) {
      return { icon: 'mdi-facebook', color: '#1877f2' };
    } else if (urlLower.includes('twitter') || urlLower.includes('x.com')) {
      return { icon: 'mdi-twitter', color: '#1da1f2' };
    } else if (urlLower.includes('instagram') || urlLower.includes('ig.com')) {
      return { icon: 'mdi-instagram', color: '#e4405f' };
    } else if (urlLower.includes('linkedin')) {
      return { icon: 'mdi-linkedin', color: '#0077b5' };
    } else if (urlLower.includes('youtube') || urlLower.includes('youtu.be')) {
      return { icon: 'mdi-youtube', color: '#ff0000' };
    } else if (urlLower.includes('telegram') || urlLower.includes('t.me')) {
      return { icon: 'mdi-telegram', color: '#0088cc' };
    } else if (urlLower.includes('whatsapp') || urlLower.includes('wa.me')) {
      return { icon: 'mdi-whatsapp', color: '#25d366' };
    } else if (urlLower.includes('tiktok')) {
      return { icon: 'mdi-music-note', color: '#000000' };
    } else if (urlLower.includes('snapchat')) {
      return { icon: 'mdi-snapchat', color: '#fffc00' };
    } else {
      return { icon: 'mdi-link', color: '#666666' };
    }
  };

  // دالة جلب بيانات المسؤول
  const fetchResponsibleData = async (institutionData) => {
    try {
      let responsibleInfo = null;

      switch (institutionData.responsible_type) {
        case 'existing_journalist':
          if (institutionData.responsible_journalist_id) {
            console.log("Fetching journalist data from:", `/journalists/${institutionData.responsible_journalist_id}`);
            const journalistRes = await api.get(`/journalists/${institutionData.responsible_journalist_id}`);
            console.log("Journalist response:", journalistRes);
            if (journalistRes.data && journalistRes.data.data) {
              setResponsibleData(journalistRes.data.data);
              console.log("Responsible data set (journalist):", journalistRes.data.data);
            }
          }
          break;

        case 'existing_activist':
          if (institutionData.responsible_activist_id) {
            console.log("Fetching activist data from:", `/activists/${institutionData.responsible_activist_id}`);
            const activistRes = await api.get(`/activists/${institutionData.responsible_activist_id}`);
            console.log("Activist response:", activistRes);
            if (activistRes.data && activistRes.data.data) {
              setResponsibleData(activistRes.data.data);
              console.log("Responsible data set (activist):", activistRes.data.data);
            }
          }
          break;

        case 'new_person':
          // شخص جديد - البيانات موجودة في نفس المؤسسة
          if (institutionData.representative_name) {
            setResponsibleData({
              full_name: institutionData.representative_name,
              gender: institutionData.representative_gender,
              id_number: institutionData.representative_id_number,
              political_orientation: institutionData.representative_political_orientation,
              profile_image: institutionData.representative_profile_image,
              // نوع الشخص الجديد
              type: institutionData.new_person_type === 'journalist' ? 'صحفي' : 'ناشط'
            });
            console.log("Responsible data set (new person):", {
              full_name: institutionData.representative_name,
              gender: institutionData.representative_gender,
              id_number: institutionData.representative_id_number,
              political_orientation: institutionData.representative_political_orientation,
              profile_image: institutionData.representative_profile_image,
              type: institutionData.new_person_type === 'journalist' ? 'صحفي' : 'ناشط'
            });
          }
          break;

        default:
          console.log("Unknown responsible type:", institutionData.responsible_type);
      }
    } catch (error) {
      console.error("فشل في جلب بيانات المسؤول:", error);
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "white",
          padding: "40px",
          textAlign: "center",
          border: "1px solid #ddd"
        }}>
          <Spinner size="lg" />
          <p style={{ marginTop: "20px", fontSize: "18px" }}>جاري تحميل بيانات المؤسسة...</p>
        </div>
      </div>
    );
  }

  if (!institution) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "white",
          padding: "40px",
          textAlign: "center",
          border: "1px solid #ddd"
        }}>
          <i className="mdi mdi-alert-circle" style={{ fontSize: "64px", color: "#666" }}></i>
          <h4 style={{ marginTop: "20px" }}>لم يتم العثور على بيانات المؤسسة</h4>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* CSS لإخفاء النافيجيتور عند الطباعة */}
      <style>
        {`
          @media print {
            /* إخفاء النافبار والفوتر بس */
            .top-navigation,
            .topnav,
            .page-title-content,
            .print-btn,
            .footer {
              display: none !important;
            }
            
            /* إعدادات عامة للطباعة */
            * {
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            
            html, body {
              margin: 0 !important;
              padding: 0 !important;
              font-size: 12pt !important;
            }
            
            /* إخفاء العناصر الخارجية اللي بتسبب الهامش */
            .main-content,
            .page-content,
            .container-fluid {
              margin: 0 !important;
              padding: 0 !important;
            }
            
            .print-content {
              display: block !important;
              visibility: visible !important;
              margin: 0 !important;
              padding: 0 !important;
              background: white !important;
            }
            
            .print-content * {
              visibility: visible !important;
            }
            
            .container {
              max-width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            
            /* تصغير العناصر تحت اسم المؤسسة عند الطباعة */
            .institution-info-tags {
              gap: 8px !important;
            }
            
            .institution-info-tag {
              padding: 3px 8px !important;
              font-size: 0.65rem !important;
              border-radius: 12px !important;
            }
            
            .institution-info-tag i {
              font-size: 11px !important;
              margin-left: 3px !important;
            }
          }
          
          /* CSS خاص لإخفاء الأزرار عند إنشاء PDF */
          .pdf-generating .print-btn {
            visibility: hidden !important;
            opacity: 0 !important;
          }
          
          .print-btn {
            background: #6366f1;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 6px;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
            min-width: 100px;
            border: 2px solid #6366f1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          }
          
          .print-btn:disabled {
            cursor: not-allowed;
            transform: none !important;
          }
          
          .print-btn:hover:not(:disabled) {
            background: #5a5fcf;
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);
            border-color: #5a5fcf;
          }
          
          .print-btn:active:not(:disabled) {
            transform: translateY(0);
          }
          
          .print-btn i {
            font-size: 14px;
          }
        `}
      </style>
      
      <div className="print-content" style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        padding: "20px"
      }}>
        <div className="container" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div style={{
            background: "white",
            border: "1px solid #ddd"
          }}>

            {/* هيدر المؤسسة */}
            <div style={{
              background: "#f8f8f8",
              color: "#333",
              padding: "40px",
              borderBottom: "1px solid #ddd"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "30px", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "30px", flex: 1 }}>
                  <div style={{ flexShrink: 0 }}>
                    {institution.logo ? (
                      <img
                        src={`${FILE_BASE_URL}/uploads/images/${institution.logo}`}
                        alt="شعار المؤسسة"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "cover",
                          border: "1px solid #ddd"
                        }}
                      />
                    ) : (
                      <div style={{
                        width: "150px",
                        height: "150px",
                        background: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #ddd"
                      }}>
                        <i className="mdi mdi-domain" style={{ fontSize: "60px", color: "#999" }}></i>
                      </div>
                    )}
                  </div>

                  <div style={{ flex: 1 }}>
                    <h1 style={{
                      fontSize: "2.5rem",
                      fontWeight: "bold",
                      marginBottom: "15px",
                      color: "#333"
                    }}>
                      {institution.title || "بدون اسم"}
                    </h1>

                    {/* مؤشر نوع الكيان */}
                    <div style={{
                      display: "inline-block",
                      background: "#f3e5f5",
                      color: "#5e35b1",
                      padding: "6px 16px",
                      borderRadius: "25px",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                      border: "1px solid #d1c4e9",
                      marginBottom: "20px",
                      boxShadow: "0 2px 4px rgba(94, 53, 177, 0.1)"
                    }}>
                      <i className="mdi mdi-domain" style={{ marginLeft: "6px", fontSize: "16px" }}></i>
                      مؤسسة
                    </div>

                    {/* معلومات إضافية تحت الاسم */}
                    <div style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      marginBottom: "20px"
                    }}>
                      {/* الصف الأول: حالة الترخيص، المرجع، التوجه */}
                      <div className="institution-info-tags" style={{
                        display: "flex",
                        gap: "15px",
                        flexWrap: "wrap"
                      }}>
                        <div className="institution-info-tag" style={{
                          background: "#6366f1",
                          padding: "6px 12px",
                          borderRadius: "16px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          color: "white",
                          border: "1px solid #5a67d8",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}>
                          <i className="mdi mdi-license" style={{ marginLeft: "4px", fontSize: "14px" }}></i>
                          حالة الترخيص: {institution.license_status || "غير محدد"}
                        </div>
                        
                        <div className="institution-info-tag" style={{
                          background: "#6366f1",
                          padding: "6px 12px",
                          borderRadius: "16px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          color: "white",
                          border: "1px solid #5a67d8",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}>
                          <i className="mdi mdi-account-supervisor" style={{ marginLeft: "4px", fontSize: "14px" }}></i>
                          مرجعية المؤسسة: {institution.reference || "غير محدد"}
                        </div>
                        
                        <div className="institution-info-tag" style={{
                          background: "#6366f1",
                          padding: "6px 12px",
                          borderRadius: "16px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          color: "white",
                          border: "1px solid #5a67d8",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}>
                          <i className="mdi mdi-trending-up" style={{ marginLeft: "4px", fontSize: "14px" }}></i>
                          توجه المؤسسة: {institution.orientation || "غير محدد"}
                        </div>
                      </div>

                      {/* الصف الثاني: الاتصال، الإيميل، العنوان */}
                      <div className="institution-info-tags" style={{
                        display: "flex",
                        gap: "15px",
                        flexWrap: "wrap"
                      }}>
                        <div className="institution-info-tag" style={{
                          background: "#7a6fbe",
                          padding: "6px 12px",
                          borderRadius: "16px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          color: "white",
                          border: "1px solid #6f64a8",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}>
                          <i className="mdi mdi-phone" style={{ marginLeft: "4px", fontSize: "14px" }}></i>
                          {institution.mobile1 || "غير محدد"}
                        </div>
                        
                        <div className="institution-info-tag" style={{
                          background: "#7a6fbe",
                          padding: "6px 12px",
                          borderRadius: "16px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          color: "white",
                          border: "1px solid #6f64a8",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}>
                          <i className="mdi mdi-email" style={{ marginLeft: "4px", fontSize: "14px" }}></i>
                          {institution.email || "غير محدد"}
                        </div>
                        
                        <div className="institution-info-tag" style={{
                          background: "#7a6fbe",
                          padding: "6px 12px",
                          borderRadius: "16px",
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          color: "white",
                          border: "1px solid #6f64a8",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}>
                          <i className="mdi mdi-map-marker" style={{ marginLeft: "4px", fontSize: "14px" }}></i>
                          {[institution.country || 'فلسطين', institution.country_province, institution.city_or_area].filter(Boolean).join(", ") || "غير محدد"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* أزرار الطباعة في الجانب الأيمن */}
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-end"
                }}>
                  <button 
                    className="print-btn" 
                    onClick={handlePrint}
                    title="طباعة الصفحة"
                    disabled={pdfLoading}
                  >
                    <i className="mdi mdi-printer"></i>
                    طباعة
                  </button>
                  
                  <button 
                    className="print-btn" 
                    onClick={handleDownloadPDF}
                    title="تحميل كـ PDF"
                    disabled={pdfLoading}
                  >
                    <i className="mdi mdi-file-pdf"></i>
                    {pdfLoading ? (
                      <>
                        <Spinner size="sm" style={{ width: '16px', height: '16px' }} />
                        <span style={{ marginLeft: 6 }}>جاري التحميل...</span>
                      </>
                    ) : (
                      'تحميل PDF'
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div style={{ padding: "40px" }}>
              
              {/* نبذة عن المؤسسة */}
              <div style={{ marginBottom: "15px", padding: "0px" }}>
                <h3 style={{
                  color: "#333",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "2px solid #333",
                  paddingBottom: "10px"
                }}>
                  نبذة عن المؤسسة
                </h3>
                <div style={{
                  background: "#f9f9f9",
                  padding: "25px",
                  border: "1px solid #ddd"
                }}>
                  {institution.description ? (
                    <div style={{ padding: "15px", background: "#fff", borderRadius: "5px", border: "1px solid #eee" }}>
                      <div dangerouslySetInnerHTML={{ __html: institution.description }} />
                    </div>
                  ) : (
                    <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                      <i className="mdi mdi-text" style={{ fontSize: "48px", marginBottom: "10px" }}></i>
                      <div>لا يوجد وصف متاح لهذه المؤسسة</div>
                    </div>
                  )}
                </div>
              </div>

              {/* تابع مسؤول المؤسسة */}
              <div style={{ marginBottom: "15px", padding: "0px" }}>
                <h3 style={{
                  color: "#333",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "2px solid #333",
                  paddingBottom: "10px"
                }}>
                  مسؤول المؤسسة
                </h3>
                <div style={{
                  background: "#f9f9f9",
                  padding: "25px",
                  border: "1px solid #ddd"
                }}>
                  {responsibleData ? (
                    <div style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}>
                      <div style={{ flexShrink: 0 }}>
                        {responsibleData.profile_image && (
                          <img
                            src={`${FILE_BASE_URL}/uploads/images/${responsibleData.profile_image}`}
                            alt="صورة المسؤول"
                            style={{
                              width: "120px",
                              height: "120px",
                              objectFit: "cover",
                              border: "1px solid #ddd",
                              borderRadius: "5px"
                            }}
                          />
                        )}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ marginBottom: "15px" }}><strong>الاسم الكامل:</strong> {responsibleData.full_name || "-"}</div>
                        <div style={{ marginBottom: "15px" }}><strong>النوع:</strong> {responsibleData.type || (institution.responsible_type === 'existing_journalist' ? 'صحفي' : institution.responsible_type === 'existing_activist' ? 'ناشط' : 'غير محدد')}</div>
                        <div style={{ marginBottom: "15px" }}><strong>الجنس:</strong> {responsibleData.gender || "-"}</div>
                        <div style={{ marginBottom: "15px" }}><strong>رقم الهوية:</strong> {responsibleData.id_number || "-"}</div>
                        <div style={{ marginBottom: "15px" }}><strong>الميول:</strong> {responsibleData.political_orientation ? 
                          (Array.isArray(responsibleData.political_orientation) 
                            ? responsibleData.political_orientation.join(", ") 
                            : responsibleData.political_orientation) 
                          : "-"}</div>
                      </div>
                    </div>
                  ) : (
                    <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                      <i className="mdi mdi-account-off" style={{ fontSize: "48px", marginBottom: "10px" }}></i>
                      <div>لا يوجد مسؤول محدد لهذه المؤسسة</div>
                    </div>
                  )}
                </div>
              </div>

              {/* معلومات التواصل */}
              <div style={{ marginBottom: "15px", padding: "0px" }}>
                <h3 style={{
                  color: "#333",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "2px solid #333",
                  paddingBottom: "10px"
                }}>
                  معلومات التواصل
                </h3>
                <div style={{
                  background: "#f9f9f9",
                  padding: "25px",
                  border: "1px solid #ddd"
                }}>
                  <div style={{ marginBottom: "15px" }}><strong>تفاصيل العنوان:</strong> {institution.address_details || "-"}</div>
                  <div style={{ marginBottom: "15px" }}><strong>رقم واتساب:</strong> {institution.whatsapp1 || "-"}</div>
                  <div style={{ marginBottom: "15px" }}><strong>تلفون/فاكس:</strong> {institution.phone_fax || "-"}</div>
                  <div style={{ marginBottom: "15px" }}><strong>أوريدو:</strong> {institution.oreedo_number || "-"}</div>
                  <div style={{ marginBottom: "15px" }}><strong>الموقع الإلكتروني:</strong> {institution.website || "-"}</div>
                  
                  {/* حسابات التواصل الاجتماعي */}
                  {institution.social_accounts && parseArrayField(institution.social_accounts).length > 0 && (
                    <div style={{ marginTop: "15px" }}>
                      <strong>حسابات التواصل الاجتماعي:</strong>
                      {parseArrayField(institution.social_accounts).map((account, index) => {
                        const socialIcon = getSocialMediaIcon(account);
                        return (
                          <div key={index} style={{ marginTop: "5px", display: "flex", alignItems: "center", gap: "10px" }}>
                            <i className={`mdi ${socialIcon.icon}`} style={{ fontSize: "18px", color: socialIcon.color }}></i>
                            <span style={{ color: "#007bff" }}>
                              {account}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintInstitutionView;